import { useEffect, useState } from "react";

// Persona chosen in the SIP "Viewing as" dropdown (set by the SNP micro-frontend)
const read = () => localStorage.getItem("sip.persona") || "admin";

const useSipPersona = () => {
  const [persona, setPersona] = useState(read);
  useEffect(() => {
    const onChange = (e) => setPersona(e.detail?.persona || read());
    const onStorage = (e) => e.key === "sip.persona" && setPersona(read());
    window.addEventListener("sip:persona", onChange);
    window.addEventListener("storage", onStorage);
    return () => {
      window.removeEventListener("sip:persona", onChange);
      window.removeEventListener("storage", onStorage);
    };
  }, []);
  return persona;
};

export default useSipPersona;
